import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import styles from "./Hamburger.module.scss"

const Hamburger = ({ open, setOpen, fakeActive, setFake }) => {
  const { t } = useTranslation()
  const [text, setText] = useState(t("Toggle navigation on"))
  useEffect(() => {
    setText(open ? t("Toggle navigation off") : t("Toggle navigation on"))
  }, [open, t])
  return (
    <button
      className={`${styles.trigger} ${fakeActive ? styles.fakeActive : ""}`}
      aria-expanded={open}
      onClick={() => (fakeActive ? setFake(false) : setOpen(!open))}
    >
      <span>{text}</span>
    </button>
  )
}

export default Hamburger
